<template>
    <el-drawer
        :title="title"
        :visible.sync="drawerShow"
        :destroy-on-close="true"
        size="414px"
        @close="close"
        append-to-body
    >
        <iframe :src="url" frameborder="0" height="100%" width="100%" sroll></iframe>
    </el-drawer>
</template>

<script>

export default {
    data(){
        return{
            drawerShow: false,
            url:'',
            sswap:process.env.VUE_APP_SSWAP_URL,
            title: '预览'
        }
    },
    methods:{
        close() {
            this.drawerShow = false;
        },
        show(url, title) {
            this.url =  url.includes(this.sswap) ? url : this.sswap + url;
            // if( !this.url.includes('previewFrom') ){
            //     this.url += this.url.includes('?') ? "&" : "?";
            //     this.url += "previewFrom=admin"
            // }
            if(title){
                this.title = title;
            }     
            this.drawerShow = true;
        },
    }
}
</script>